export default "__VITE_PUBLIC_ASSET__c8ec628c__"